import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import INFSe from "Types/INFSe";
import { State } from "store/reducers";

export const GET_NFSE = "[NFSE GET] GET_NFSE";
export const GET_NFSE_SUCCESS = "[NFSE GET] GET_NFSE_SUCCESS";
export const GET_NFSE_FAILED = "[NFSE GET] GET_NFSE_FAILED";

export const SET_VALUE = "[NFSE GET] SET_VALUE";
export const CLEAR_VALUES = "[NFSE GET] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getNFSe(id: string, callback?: Callback<INFSe>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_NFSE });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/NFSe/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_NFSE_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_NFSE_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_NFSE_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export const GET_SPLITS = "[NFSE GET] GET_SPLITS";
export const GET_SPLITS_SUCCESS = "[NFSE GET] GET_SPLITS_SUCCESS";
export const GET_SPLITS_FAILED = "[NFSE GET] GET_SPLITS_FAILED";

export function getSplits(id: string, callback?: Callback<INFSe>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_SPLITS });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/NFSe/" + id + "/Splits", {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_SPLITS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_SPLITS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_SPLITS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export const CREATE_SPLIT = "[NFSE GET] CREATE_SPLIT";
export const CREATE_SPLIT_SUCCESS = "[NFSE GET] CREATE_SPLIT_SUCCESS";
export const CREATE_SPLIT_FAILED = "[NFSE GET] CREATE_SPLIT_FAILED";

export function createSplit(id: any, model: any, callback?: Callback<INFSe>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_SPLIT });

		try {
			const { login } = getState() as State;

			const response = await api.sendPost("/NFSe/" + id + "/Splits", model, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: CREATE_SPLIT_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_SPLIT_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			callback && callback(error);

			return dispatch({
				type: CREATE_SPLIT_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
